export const EST_TIME_ZONE = 'America/New_York';

function toValidDate(value: string | Date | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatDateTimeEst(
  value: string | Date | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = toValidDate(value);
  if (!date) {
    return '-';
  }

  return new Intl.DateTimeFormat('en-US', {
    timeZone: EST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  }).format(date);
}

export function formatDateEst(value: string | Date | null | undefined): string {
  return formatDateTimeEst(value, {
    hour: undefined,
    minute: undefined,
    second: undefined,
  });
}

export function getEstDayKey(value: string | Date | null | undefined): string | null {
  const date = toValidDate(value);
  if (!date) {
    return null;
  }

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: EST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const map: Record<string, string> = {};
  for (const part of formatter.formatToParts(date)) {
    if (part.type !== 'literal') {
      map[part.type] = part.value;
    }
  }

  return `${map.year}-${map.month}-${map.day}`;
}

export function isSameEstDay(
  left: string | Date | null | undefined,
  right: string | Date | null | undefined,
): boolean {
  const leftKey = getEstDayKey(left);
  const rightKey = getEstDayKey(right);
  return Boolean(leftKey && rightKey && leftKey === rightKey);
}
